{
  "privileges": {
    "menu_comment": "============= SEZIONE MENU ==============",
    "voiceMenu": {
      "MENU_DASHBOARD": "MENU_DASHBOARD",
      "MENU_SETTINGS": "MENU_SETTINGS",
      "MENU_COMPANY": "MENU_COMPANY",
      "MENU_SITES": "MENU_SITES",
      "MENU_USERS": "MENU_USERS",
      "MENU_WORKFLOW": "MENU_WORKFLOW",
      "MENU_DEPOSITS": "MENU_DEPOSITS",
      "MENU_PAYMENTS": "MENU_PAYMENTS",
      "MENU_DISCOUNTS": "MENU_DISCOUNTS",
      "MENU_RATE": "MENU_RATE",
      "MENU_PROJECT": "MENU_PROJECT",
      "MENU_PROJECT_CATEGORY": "MENU_PROJECT_CATEGORY",
      "MENU_PROJECT_TYPE": "MENU_PROJECT_TYPE",
      "MENU_ARCHIVES": "MENU_ARCHIVES",
      "MENU_SUBCONTRACTOR": "MENU_SUBCONTRACTOR",
      "MENU_ACCOUNTS": "MENU_ACCOUNTS",
      "MENU_ITEMS": "MENU_ITEMS",
      "MENU_ITEM_PURPOSES": "MENU_ITEM_PURPOSES",
      "MENU_ITEM_CATEGORIES": "MENU_ITEM_CATEGORIES",
      "MENU_PRECONF_ITEMS": "MENU_PRECONF_ITEMS",
      "MENU_PRICE_LISTS": "MENU_PRICE_LISTS",
      "MENU_PRECONF_CUSTOMER_LIST": "MENU_PRECONF_CUSTOMER_LIST",
      "MENU_ORDERS": "MENU_ORDERS",
      "MENU_ORDER_TYPES": "MENU_ORDER_TYPES",
      "MENU_RECEIVABLES": "MENU_RECEIVABLES",
      "MENU_QUOTES": "MENU_QUOTES",
      "MENU_ADVANCE_PAYMENTS": "MENU_ADVANCE_PAYMENTS",
      "MENU_BOM": "MENU_BOM",
      "MENU_SAL_PROJECT": "MENU_SAL_PROJECT",
      "MENU_SAL": "MENU_SAL",
      "MENU_CUST_INVOICE": "MENU_CUST_INVOICE",
      "MENU_NUMBERING_ORDERS": "MENU_NUMBERING_ORDERS",
      "MENU_CUSTOMER_ORDERS": "MENU_CUSTOMER_ORDERS",
      "MENU_SUPPLIER_ORDERS": "MENU_SUPPLIER_ORDERS",
      "MENU_WAREHOUSE": "MENU_WAREHOUSE",
      "MENU_INVENTORY_MOVEMENT": "MENU_INVENTORY_MOVEMENT"
    },
    "user_comment": "============= SEZIONE UTENTE =============",
    "user": {
      "create": "Creazione di un utente",
      "SUPERADMIN": "Visualizzazione ruolo SUPERADMIN nel multiselect",
      "STORE_MANAGER": "Visualizzazione ruolo STORE_MANAGER nel multiselect",
      "STORE_VIEWER": "Visualizzazione ruolo STORE_VIEWER nel multiselect",
      "EXTERNAL_TECHNICIAN": "Visualizzazione ruolo EXTERNAL_TECHNICIAN nel multiselect",
      "SECURITY_REFERENT": "Visualizzazione ruolo SECURITY_REFERENT nel multiselect"
    },
    "subcontractor_comment": "============= SEZIONE SUBAPPALTATORE =============",
    "subcontractor": {
      "create": "Creazione di un subappaltatore"
    },
    "projectCategory_comment": "======== SEZIONE CATEGORIA PROGETTO ========",
    "projectCategory": {
      "create": "Creazione di una categoria di progetto"
    },
    "projectType_comment": "======== SEZIONE TIPOLOGIA PROGETTO ========",
    "projectType": {
      "create": "Creazione di una tipologia di progetto"
    },
    "workflow_comment": "============= SEZIONE WORKFLOW =============",
    "workflow": {
      "create": "Creazione di un workflow"
    },
    "project_comment": "============= SEZIONE PROGETTO =============",
    "project": {
      "create": "Creazione di un progetto",
      "viewAssociatedUsers": "Visualizzazione tab Utenti associati progetto",
      "viewSpecificationsInfo": "Visualizzazione tab Dati Capitolato",
      "viewRegistryCustomer": "Visualizzazione tab Anagrafiche clienti progetto",
      "viewRegistrySubcontractor": "Visualizzazione tab Anagrafiche subappaltatori progetto",
      "viewWorkflow": "Visualizzazione tab Workflow progetto",
      "viewSecurity": "Visualizzazione tab Sicurezza progetto",
      "viewDocumentsWorkflow": "Visualizzazione tab Documenti workflow progetto",
      "viewDocumentsSecurity": "Visualizzazione tab Documenti sicurezza progetto",
      "viewReminder": "Visualizzazione tab Promemoria progetto",
      "editSpecificationsInfo": "Modifica Dati Capitolato",
      "editInformations": "Modifica dati Informazioni progetto",
      "editAssociatedUsers": "Modifica dati Utenti associati progetto",
      "editRegistryCustomer": "Modifica dati Anagrafiche clienti progetto",
      "editRegistrySubcontractor": "Modifica dati Anagrafiche subappaltatori progetto",
      "editWorkflow": "Modifica dati Workflow progetto",
      "editSecurity": "Modifica dati Sicurezza progetto",
      "editDocumentsWorkflow": "Modifica dati Documenti workflow progetto",
      "editDocumentsSecurity": "Modifica dati Documenti sicurezza progetto",
      "editReminder": "Modifica dati Promemoria progetto"
    }
  },
  "roles": {
    "SUPERADMIN": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_SETTINGS",
        "MENU_COMPANY",
        "MENU_SITES",
        "MENU_USERS",
        "MENU_WORKFLOW",
        "MENU_DEPOSITS",
        "MENU_PAYMENTS",
        "MENU_DISCOUNTS",
        "MENU_RATE",
        "MENU_ARCHIVES",
        "MENU_SUBCONTRACTOR",
        "MENU_ACCOUNTS",
        "MENU_ITEMS",
        "MENU_ITEM_PURPOSES",
        "MENU_ITEM_CATEGORIES",
        "MENU_PRECONF_ITEMS",
        "MENU_PRICE_LISTS",
        "MENU_PRECONF_CUSTOMER_LIST",
        "MENU_PROJECT",
        "MENU_PROJECT_CATEGORY",
        "MENU_PROJECT_TYPE",
        "MENU_ORDERS",
        "MENU_ORDER_TYPES",
        "MENU_RECEIVABLES",
        "MENU_QUOTES",
        "MENU_ADVANCE_PAYMENTS",
        "MENU_BOM",
        "MENU_SAL_PROJECT",
        "MENU_SAL",
        "MENU_CUST_INVOICE",
        "MENU_NUMBERING_ORDERS",
        "MENU_CUSTOMER_ORDERS",
        "MENU_SUPPLIER_ORDERS",
        "MENU_WAREHOUSE",
        "MENU_INVENTORY_MOVEMENT"
      ],
      "user": [
        "create",
        "SUPERADMIN",
        "STORE_MANAGER",
        "STORE_VIEWER",
        "EXTERNAL_TECHNICIAN",
        "SECURITY_REFERENT",
        "ADMINISTRATION",
        "LOGISTIC"
      ],
      "subcontractor": [
        "create"
      ],
      "projectCategory": [
        "create"
      ],
      "projectType": [
        "create"
      ],
      "workflow": [
        "create"
      ],
      "project": [
        "create",
        "viewAssociatedUsers",
        "viewSpecificationsInfo",
        "viewRegistryCustomer",
        "viewRegistrySubcontractor",
        "viewWorkflow",
        "viewSecurity",
        "viewDocumentsWorkflow",
        "viewDocumentsSecurity",
        "viewReminder",
        "editSpecificationsInfo",
        "editInformations",
        "editAssociatedUsers",
        "editRegistryCustomer",
        "editRegistrySubcontractor",
        "editWorkflow",
        "editSecurity",
        "editDocumentsWorkflow",
        "editDocumentsSecurity",
        "editReminder"
      ]
    },
    "ADMINISTRATION": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_SETTINGS",
        "MENU_COMPANY",
        "MENU_SITES",
        "MENU_USERS",
        "MENU_WORKFLOW",
        "MENU_DEPOSITS",
        "MENU_PAYMENTS",
        "MENU_DISCOUNTS",
        "MENU_RATE",
        "MENU_ARCHIVES",
        "MENU_SUBCONTRACTOR",
        "MENU_ACCOUNTS",
        "MENU_ITEMS",
        "MENU_ITEM_PURPOSES",
        "MENU_ITEM_CATEGORIES",
        "MENU_PRECONF_ITEMS",
        "MENU_PRICE_LISTS",
        "MENU_PRECONF_CUSTOMER_LIST",
        "MENU_PROJECT",
        "MENU_PROJECT_CATEGORY",
        "MENU_PROJECT_TYPE",
        "MENU_ORDERS",
        "MENU_ORDER_TYPES",
        "MENU_RECEIVABLES",
        "MENU_QUOTES",
        "MENU_ADVANCE_PAYMENTS",
        "MENU_BOM",
        "MENU_SAL_PROJECT",
        "MENU_SAL",
        "MENU_CUST_INVOICE",
        "MENU_NUMBERING_ORDERS",
        "MENU_CUSTOMER_ORDERS",
        "MENU_SUPPLIER_ORDERS",
        "MENU_WAREHOUSE",
        "MENU_INVENTORY_MOVEMENT"
      ],
      "user": [
        "create",
        "SUPERADMIN",
        "STORE_MANAGER",
        "STORE_VIEWER",
        "EXTERNAL_TECHNICIAN",
        "SECURITY_REFERENT"
      ],
      "subcontractor": [
        "create"
      ],
      "projectCategory": [
        "create"
      ],
      "projectType": [
        "create"
      ],
      "workflow": [
        "create"
      ],
      "project": [
        "create",
        "viewAssociatedUsers",
        "viewSpecificationsInfo",
        "viewRegistryCustomer",
        "viewRegistrySubcontractor",
        "viewWorkflow",
        "viewSecurity",
        "viewDocumentsWorkflow",
        "viewDocumentsSecurity",
        "viewReminder",
        "editSpecificationsInfo",
        "editInformations",
        "editAssociatedUsers",
        "editRegistryCustomer",
        "editRegistrySubcontractor",
        "editWorkflow",
        "editSecurity",
        "editDocumentsWorkflow",
        "editDocumentsSecurity",
        "editReminder"
      ]
    },
    "LOGISTIC": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_ARCHIVES",
        "MENU_ITEMS",
        "MENU_PRICE_LISTS",
        "MENU_PROJECT",
        "MENU_ORDERS",
        "MENU_RECEIVABLES",
        "MENU_QUOTES",
        "MENU_ADVANCE_PAYMENTS",
        "MENU_BOM",
        "MENU_SAL_PROJECT",
        "MENU_SAL",
        "MENU_CUST_INVOICE",
        "MENU_CUSTOMER_ORDERS",
        "MENU_SUPPLIER_ORDERS",
        "MENU_WAREHOUSE",
        "MENU_INVENTORY_MOVEMENT"
      ],
      "user": [],
      "projectCategory": [],
      "projectType": [],
      "workflow": [],
      "project": []
    },
    "STORE_MANAGER": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_ARCHIVES",
        "MENU_SUBCONTRACTOR",
        "MENU_ACCOUNTS",
        "MENU_ITEMS",
        "MENU_ITEM_CATEGORIES",
        "MENU_PRICE_LISTS",
        "MENU_PROJECT",
        "MENU_ORDERS",
        "MENU_RECEIVABLES",
        "MENU_QUOTES",
        "MENU_ADVANCE_PAYMENTS",
        "MENU_BOM",
        "MENU_SAL_PROJECT",
        "MENU_SAL",
        "MENU_CUST_INVOICE",
        "MENU_CUSTOMER_ORDERS",
        "MENU_SUPPLIER_ORDERS",
        "MENU_WAREHOUSE",
        "MENU_INVENTORY_MOVEMENT"
      ],
      "user": [
        "create",
        "STORE_MANAGER",
        "STORE_VIEWER",
        "EXTERNAL_TECHNICIAN",
        "SECURITY_REFERENT"
      ],
      "subcontractor": [
        "create"
      ],
      "projectCategory": [
        "create"
      ],
      "projectType": [
        "create"
      ],
      "workflow": [
        "create"
      ],
      "project": [
        "create",
        "viewAssociatedUsers",
        "viewSpecificationsInfo",
        "viewRegistryCustomer",
        "viewRegistrySubcontractor",
        "viewWorkflow",
        "viewSecurity",
        "viewDocumentsWorkflow",
        "viewDocumentsSecurity",
        "viewReminder",
        "editSpecificationsInfo",
        "editInformations",
        "editAssociatedUsers",
        "editRegistryCustomer",
        "editRegistrySubcontractor",
        "editWorkflow",
        "editReminder"
      ]
    },
    "STORE_VIEWER": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_ARCHIVES",
        "MENU_SUBCONTRACTOR",
        "MENU_ACCOUNTS",
        "MENU_ITEMS",
        "MENU_PRICE_LISTS",
        "MENU_PROJECT",
        "MENU_ORDERS",
        "MENU_CUSTOMER_ORDERS",
        "MENU_SUPPLIER_ORDERS",
        "MENU_WAREHOUSE",
        "MENU_INVENTORY_MOVEMENT"
      ],
      "user": [],
      "subcontractor": [],
      "projectCategory": [],
      "projectType": [],
      "workflow": [],
      "project": [
        "viewAssociatedUsers",
        "viewSpecificationsInfo",
        "viewRegistryCustomer",
        "viewRegistrySubcontractor",
        "viewWorkflow",
        "viewSecurity",
        "viewDocumentsWorkflow",
        "viewDocumentsSecurity",
        "viewReminder",
        "editReminder"
      ]
    },
    "CUSTOMER": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_ARCHIVES",
        "MENU_PROJECT",
        "MENU_ORDERS",
        "MENU_WAREHOUSE"
      ],
      "user": [],
      "subcontractor": [],
      "projectCategory": [],
      "projectType": [],
      "workflow": [],
      "project": []
    },
    "EXTERNAL_TECHNICIAN": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_ARCHIVES",
        "MENU_PROJECT",
        "MENU_ORDERS",
        "MENU_WAREHOUSE"
      ],
      "user": [],
      "subcontractor": [],
      "projectCategory": [],
      "projectType": [],
      "workflow": [],
      "project": [
        "viewWorkflow",
        "viewDocumentsWorkflow",
        "viewReminder",
        "editWorkflow",
        "editReminder"
      ]
    },
    "SUBCONTRACTOR": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_ARCHIVES",
        "MENU_PROJECT",
        "MENU_ORDERS",
        "MENU_WAREHOUSE"
      ],
      "user": [],
      "subcontractor": [],
      "projectCategory": [],
      "projectType": [],
      "workflow": [],
      "project": [
        "viewSecurity",
        "viewDocumentsSecurity",
        "viewReminder",
        "editReminder"
      ]
    },
    "SECURITY_REFERENT": {
      "voiceMenu": [
        "MENU_DASHBOARD",
        "MENU_ARCHIVES",
        "MENU_PROJECT",
        "MENU_ORDERS",
        "MENU_WAREHOUSE"
      ],
      "user": [],
      "subcontractor": [],
      "projectCategory": [],
      "projectType": [],
      "workflow": [],
      "project": [
        "viewSecurity",
        "viewDocumentsSecurity",
        "viewReminder",
        "editReminder",
        "editSecurity"
      ]
    }
  }
}